(() => {
  const cleanContactPostUrl = () => {
    try {
      const cleanUrl = new URL(window.location.href);
      cleanUrl.searchParams.delete('contact_posted');
      cleanUrl.hash = '';
      window.history.replaceState({}, document.title, cleanUrl.pathname + cleanUrl.search);
    } catch (_) {}
  };

  const initOfferForm = (root) => {
    if (!root || root.dataset.evwOfferReady === 'true') return;
    const toggle = root.querySelector('[data-evw-offer-toggle]');
    const panel = root.querySelector('[data-evw-offer-form]');
    if (!toggle || !panel) return;
    root.dataset.evwOfferReady = 'true';
    const success = panel.querySelector('[data-evw-offer-success]');
    const errors = panel.querySelector('[data-evw-offer-errors]');
    const close = panel.querySelector('[data-evw-offer-success-close]');
    const fields = panel.querySelector('[data-evw-offer-fields]');
    const firstField = panel.querySelector('[data-evw-offer-first-field]');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const setOpen = (open, focusField = false) => {
      panel.hidden = !open;
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open && focusField) window.requestAnimationFrame(() => firstField?.focus({ preventScroll: true }));
    };

    toggle.addEventListener('click', () => {
      const willOpen = panel.hidden;
      setOpen(willOpen, willOpen && !success);
      if (willOpen) panel.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'nearest' });
    });

    close?.addEventListener('click', () => {
      if (success) success.hidden = true;
      if (fields) fields.hidden = false;
      cleanContactPostUrl();
      setOpen(true, true);
    });

    if (success || errors) {
      setOpen(true, false);
      window.setTimeout(() => {
        const target = success || errors;
        target?.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'center' });
        if (success) success.focus({ preventScroll: true });
      }, 100);
    } else {
      setOpen(false, false);
    }
  };

  const initAll = (scope = document) => scope.querySelectorAll('[data-evw-final]').forEach(initOfferForm);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll(), { once: true }); else initAll();
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
